import React from 'react';
import { PageNotFound } from '../src/components/layouts/ErrorLayouts';


export default function Error404() {
    return (
        <PageNotFound />
    );
}
